const LoadingGraphics = () => {

  return (
    <div className="h100 d-flex justify-content-center align-items-center">
      <div
        id="spinner-border-width"
        className="spinner-border loading text_theme"
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default LoadingGraphics;
